// Verifications
const VerificationList = () => import('@/views/verifications/VerificationList.vue')
const VerificationForm = () => import('@/views/verifications/VerificationForm.vue')
const VerificationPrint = () => import('@/views/verifications/VerificationPrint.vue')
const VerificationReport = () => import('@/views/verifications/VerificationReport.vue')

export const verificationRoutes = [
  {
    path: '/verifications',
    name: 'Verifications',
    component: VerificationList,
    meta: {
      requireAuth: true,
      title: 'Verifications'
    }
  },
  {
    path: '/verifications/new',
    name: 'NewVerification',
    component: VerificationForm,
    meta: {
      requireAuth: true,
      title: 'New Verification'
    }
  },
  {
    path: '/verifications/:id',
    name: 'ViewVerification',
    component: VerificationReport,
    props: route => ({
      tab: 'coverage', // Default tab prop
      ...route.params // Pass route params (including id) as props
    }),
    meta: {
      requireAuth: true,
      title: 'Verification Details'
    }
  },
  {
    path: '/verifications/:id/edit',
    name: 'EditVerification',
    component: VerificationForm,
    meta: {
      requireAuth: true,
      title: 'Edit Verification'
    }
  },
  {
    path: '/verifications/:id/print',
    name: 'PrintVerification',
    component: VerificationPrint,
    meta: {
      requireAuth: true,
      title: 'Print Verification'
    }
  }
]
